import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import logo from '../../../assets/Images/logos/logodark.svg'
import vector from '../../../assets/vector/errorvector.svg'
import useScreenWidth from '../hooks/useScreenWidth'

function NotFound({ showLogo = true }: { showLogo?: boolean }) {
  const { t } = useTranslation(['global'])
  const isTablet = useScreenWidth(960)
  const navigate = useNavigate()

  return (
    <Box
      sx={theme => ({
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.grey[50],
        width: '100%',
        minHeight: '90vh'
      })}
    >
      {showLogo && (
        <Box p={7} pb={0}>
          <img src={logo} width="86.37" alt="logo" />
        </Box>
      )}
      <Box flexDirection="column" alignItems="center" justifyContent="space-between" display="flex" pt={5}>
        <img src={vector} width={isTablet ? '75%' : '25%'} alt="logo" />
        <Box justifyContent="center" alignContent="center" display="flex" pt={8} pb={8} px={4} maxWidth="630px" gap={'32px'}>
          <Box width="4px" height="auto" sx={theme => ({ backgroundColor: theme.palette.primary.main, width: 16 })} />
          <Box gap={'16px'} display="grid">
            <Typography variant="h3" color="inherit">
              {t('page-not-found')}
            </Typography>
            <Typography variant="body1" color="inherit">
              {t('page-not-found-copy', { APP_NAME: import.meta.env.VITE_NAME })}
            </Typography>
          </Box>
        </Box>
        <Box p={3} width="-webkit-fill-available" textAlign="center">
          <Button variant="contained" fullWidth sx={{ maxWidth: '442px', marginBottom: 64 }} onClick={() => navigate(-1)}>
            {t('back')}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default NotFound
